import ErrorNotification, { ErrorNotificationProps } from './ErrorNotification';

export type { ErrorNotificationProps };
export default ErrorNotification;
